import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem } from "@blueprintjs/core";
import _ from "lodash";
import { List } from "immutable";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";

// Actions
import { getWarehouses, changeWarehouseStatus, cleanWarehouses } from "../../../actions/warehouses";

class WarehousesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            warehousesFilter: ''
        };
    }
    componentDidMount() {
      this.props.getWarehouses({
          projection: 'warehouse_code name comments status',
          deleteVirtuals: true
      });
    };
    componentWillUnmount() {
        this.props.cleanWarehouses();
    }

    render() {

        const { warehouses, history } = this.props;
        const { warehousesFilter } = this.state;

        let tableData = warehouses;
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ warehouses.size }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: '' }) } >
                                <strong>Total</strong>
                            </span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ warehouses.count(warehouse => warehouse.get('status') === 'active') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: 'active' }) } >Activos</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ warehouses.count(warehouse => warehouse.get('status') === 'inactive') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: 'inactive' }) } >Inactivos</span>
                </div>
            </div>
        );

        // Filters
        switch (warehousesFilter) {
            case 'active':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ warehouses.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: '' }) } >Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">
                                <strong>{ warehouses.count(warehouse => warehouse.get('status') === 'active') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: 'active' }) } >
                                <strong>Activos</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ warehouses.count(warehouse => warehouse.get('status') === 'inactive') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: 'inactive' }) } >Inactivos</span>
                        </div>
                    </div>
                );
                tableData = warehouses.filter( warehouse => warehouse.get('status') === 'active' );
                break;
            case 'inactive':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ warehouses.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: '' }) } >Total</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ warehouses.count(warehouse => warehouse.get('status') === 'active') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: 'active' }) } >Activos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">
                                <strong>{ warehouses.count(warehouse => warehouse.get('status') === 'inactive') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ warehousesFilter: 'inactive' }) } >
                                <strong>Inactivos</strong>
                            </span>
                        </div>
                    </div>
                );
                tableData = warehouses.filter( warehouse => warehouse.get('status') === 'inactive' );
                break;
            default :
                break;
        }

        // Warehouses Table
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            warehouse_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'warehouse_code'],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/almacenes/' + value[0] }>{ value[1] }</Link>
                }
            },
            name: {
                title: "Nombre",
                columnType: 'function',
                dataField: ['_id', 'name'],
                width: 200,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/almacenes/' + value[0] }>{ value[1] }</Link>
                }
            },
            comments: {
                title: "Comentarios",
                columnType: 'text',
                dataField: 'comments',
                width: 200,
                style: {},
                sortable: false,
                filterable: true,
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let data = value === 'active'
                        ? { badgeColor: 'primary', value: 'activo' }
                        : value === 'inactive'
                            ? { badgeColor: 'danger', value: 'inactivo' }
                            : { badgeColor: 'info', value };

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {_.capitalize(data.value)}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => history.push('/almacenes/' + value[0])} />
                            <MenuItem icon="eye-open" text="Ver stock" onClick={ () => history.push('/almacenes/' + value[0] + '/stock')} />
                            { value[1] === 'active'
                                ? <MenuItem onClick={ () => this.props.changeWarehouseStatus(value[0], 'inactive') } icon="eye-off" text="Desactivar" />
                                : value[1] === 'inactive'
                                    ? <MenuItem onClick={ () => this.props.changeWarehouseStatus(value[0], 'active') } icon="eye-off" text="Activar" />
                                    : null
                            }
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                Configuración
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Almacenes</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => history.push('/almacenes/nuevo') } > <Icon icon="insert"/>Almacén</button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    {statsZone}
                    <div className="row">
                        <div className="col">

                            <div className="ibox">
                                <div className="ibox-content">
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const warehousesReducer = state.warehouses;

    // Warehouses
    let warehouses = warehousesReducer.get('payload') || List([]);

    if (!(warehouses instanceof List)) {
        warehouses = List([]);
    }

    return {
        warehouses
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getWarehouses: (query) => dispatch(getWarehouses(query)),
        changeWarehouseStatus: (warehouseId, status) => dispatch(changeWarehouseStatus(warehouseId, status)),
        cleanWarehouses: () => dispatch(cleanWarehouses())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WarehousesPage);


// WEBPACK FOOTER //
// ./src/containers/configuration/warehouses/WarehousesPage.js